module.exports = __webpack_public_path__ + "img/Gambling.781b2259.png";